import { useAppSelector } from "./redux_hooks";

import { CapabilityType, RootState } from "shared/types";

type UseCapabilitiesOptionsType = {
  userId?: string;
};

export function useCapabilities(options: UseCapabilitiesOptionsType = {}) {
  return useAppSelector(
    (state: RootState) => {
      const _userId = options.userId || state.local.currentUserId;
      const capabilities = state.classroom.client.capabilities;
      return Object.fromEntries(
        Object.entries(capabilities).map(([capability, userIds]) => [
          capability,
          userIds.includes(_userId),
        ]),
      );
    },
    (a, b) => {
      return Object.keys(a).every((key) => a[key] === b[key]);
    },
  );
}

export function useCapability(
  capability: CapabilityType,
  options: UseCapabilitiesOptionsType = {},
) {
  return useAppSelector((state: RootState) => {
    const _userId = options.userId || state.local.currentUserId;
    const capabilities = state.classroom.client.capabilities;
    return capabilities[capability].includes(_userId);
  });
}

export function useUserIdsWithCapability(capability: CapabilityType) {
  return useAppSelector(
    (state: RootState) => state.classroom.client.capabilities[capability] || [],
  );
}
